<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('returnFromVendor.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('returnFromVendor.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{
              $t('add_new')
              }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width:200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
              v-tooltip="$t('returnFromVendor.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
					:expandable="true"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.return_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.return_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.return_to_vendor.return_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.remarks }}</td>
						<td class="text-center ts-space-x-3">
							<a href="#" v-tooltip="$t('edit')" class="text-primary" @click.prevent="edit(record)">
								<i class="fas fa-edit"></i>
							</a>
							<a-popconfirm
								placement="leftTop"
								:title="$t('are_you_sure_to_delete')"
								:ok-text="$t('yes')"
								:cancel-text="$t('no')"
								@confirm="deleteRecord(record)"
							>
								<a href="#" :disabled="record._deleting">
									<i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
									<i class="fa fa-trash text-red" v-else></i>
								</a>
							</a-popconfirm>
						</td>
          </template>
					<div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto">
              <thead>
                <tr>
                    <th>{{ $t('returnFromVendor.productName') }}</th>
                    <th>{{ $t('returnFromVendor.uom') }}</th>
                    <th>{{ $t('returnFromVendor.cost') }}</th>
                    <th>{{ $t('returnFromVendor.quantity') }}</th>
                </tr>
              </thead>
              <tbody>
								<template
									v-for="(product, index) in prop.record.details"
								>								
									<tr
										:key="index"
									>
										<td>{{ product.product_name_en }}</td>
										<td>{{ product.uom_name_en }}</td>
										<td>{{ product.cost }}</td>
										<td>{{ product.quantity }}</td>
									</tr>
									<tr
										v-if="product.serials.length"
									>
										<td colspan="4">
											<div class=" ts-pl-3 ts-space-y-2 ts-space-x-1">
											<div class="ts-border-blue-200 ts-border ts-p-2 ts-rounded ts-font-bold w-fit ts-inline-block"
												v-for="serial in product.serials"
												:key="serial.serial_no"
											>
												{{ serial.serial_no }}
											</div>
										</div>
										</td>
									</tr>
								</template>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
	name: 'stockReturnFromendor',
	data(){
		return{
      loading: false
		}
  },
  created(){
    this.$store.state.stock.returnFromVendor.dateRange = [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
  },
  computed: {
    ...mapState('stock/returnFromVendor', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stock.returnFromVendor.search
      },
      set(newValue) {
        this.$store.commit('stock/returnFromVendor/SET_SEARCH', newValue)
        this.$store.commit('stock/returnFromVendor/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.stock.returnFromVendor.dateRange
      },
      set(newValue) {
        this.$store.commit('stock/returnFromVendor/SET_DATE_RANGE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('returnFromVendor.returnDate') },
        { name: this.$t('returnFromVendor.returnFromNumber') },
        { name: this.$t('returnFromVendor.returnToNumber') },
        { name: this.$t('returnFromVendor.remark') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        }
      ]
    }
  },
	methods: {
		addNew(){
			this.$router.push({ name: 'return-from-vendor-create'})
		},
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/returnFromVendor/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
			this.$store.commit('stock/returnFromVendor/SET_EDIT_DATA', record)
			this.$router.push({ name: 'return-from-vendor-edit', params:{ id: record.return_from_vendor_id }})
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('stock/returnFromVendor/destroy', record.return_from_vendor_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
	},
	watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/returnFromVendor/RESET_STATE')
    next()
  }
}
</script>